import { animated, useSpring } from '@react-spring/web'
import { type ReactNode } from 'react'
import useMeasure from 'react-use-measure'

const AnimateHeight = ({ children }: { children: ReactNode }) => {
  const [ref, bounds] = useMeasure()

  const spring = useSpring({
    height: bounds.height,
    config: { tension: 250, friction: 30 }
  })

  return (
    <animated.div style={{ overflow: 'hidden', ...spring }}>
      <div ref={ref}>
        {children}
      </div>
    </animated.div>
  )
}

export default AnimateHeight
